export enum FilterTypes {
  HomeCompetitors = 0,
  AwayCompetitors = 1,
  HomeParticipants = 2,
  AwayParticipants = 3,
  Venues = 4,
  StartDates = 5,
  FixtureTypes = 6,
  FixtureStatuses = 7,
  Stages = 8,
  Pools = 9,
  Series = 10,
}
